<div class="h-100 d-flex flex-column">
  <div class="container-fluid">
    <div class="homepage-container">
      <div class="homepage-content">
        <h1>
          <span class="homepage-greeting d-block"
                [translate]="'HOMEPAGE.PAGE-TITLE'"></span>
          <span class="homepage-greeting-subtext d-block"
                [translate]="'HOMEPAGE.PAGE-TITLE-SUBTEXT'"></span>
        </h1>
        <div class="homepage-form">
          <div class="mb-3 has-icon-input-lg typeahead-group-input shadow">
            <label for="departmentTypeInput"
                   class="visually-hidden"
                   [translate]="'HOMEPAGE.DEPARTMENT-INPUT.LABEL'"></label>
            <i-feather name="search"
                       class="stroke-navy"></i-feather>
            <select id="departmentTypeInput"
                    name="departmentTypeInput"
                    [(ngModel)]="selectedDepartment"
                    class="form-control form-control-lg border-0 focus-color-navy"
                    autocomplete="off">
              <option value="undefined"
                      hidden
                      disabled
                      selected>{{ 'HOMEPAGE.DEPARTMENT-INPUT.PLACEHOLDER' | translate }}
              </option>
              <option [ngValue]="department"
                      *ngFor="let department of departments"> {{ department.name }}
              </option>
            </select>
          </div>

          <app-places-autocomplete (selectedPlace)="onPlaceSelected($event)">
          </app-places-autocomplete>

          <div class="shadow d-grid">
            <button role="button"
                    class="btn btn-cta btn-lg"
                    (click)="searchSalons()"
                    [translate]="'HOMEPAGE.BUTTON-SEARCH'">Zoek</button>
          </div>

        </div>

      </div>
    </div>
  </div>

  <app-gifts-advertisement class="mt-auto">
  </app-gifts-advertisement>

</div>
